import { render, staticRenderFns } from "./WaitList.vue?vue&type=template&id=296e5777&scoped=true&"
import script from "./WaitList.vue?vue&type=script&lang=js&"
export * from "./WaitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e5777",
  null
  
)

export default component.exports